module.exports = __webpack_public_path__ + "static/media/how_to_migrate.148210fb.png";